// Goals by Time Band — types + selection (Phase 3, D3 SVG bar chart).
//
// Per team, goals scored (green, up) vs conceded (red, down) across six 15-min
// time bands — a diverging bar chart around a baseline. The bar geometry + D3
// animation live in the component; the pure part is just picking the window.

type Window = "5" | "10" | "Season";

/** One time band: its label + goals scored / conceded in that band. */
export interface GtbBand {
  l: string;
  s: number;
  c: number;
}

/** Goals-by-time-band data keyed by full team name, then window. */
export type GtbData = Record<string, Record<Window, GtbBand[]>>;

/** Normalise the timeline control to a data key (anything but 10/Season → 5). */
function toWindow(timeline: string | null | undefined): Window {
  return timeline === "10" ? "10" : timeline === "Season" ? "Season" : "5";
}

/** The bands for a team + window (`[]` when missing). */
export function selectGtbBands(
  data: GtbData,
  team: string,
  timeline: string | null | undefined
): GtbBand[] {
  return data[team]?.[toWindow(timeline)] ?? [];
}
